import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="border-b border-border">
        <div className="container-tight py-24 md:py-32 max-w-4xl">
          <div className="overline">About the fund</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tight mt-6 leading-[1.02] max-w-3xl">
            A direct line between <span className="text-primary">golfers and the people</span> who want to back them.
          </h1>
          <p className="mt-10 text-lg leading-relaxed text-foreground/70 max-w-2xl">
            The TGI Golfer Fund is a funding platform for golfers. Travel, entry fees, coaching and equipment add up
            fast, and too many promising players walk away from the game before their talent has a chance to
            compete at the level it deserves.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-foreground/70 max-w-2xl">
            The platform lets golfers raise money for their sporting endeavours directly from the people who want to
            support them. Supporters find a golfer, back them one-off or monthly. Sponsors pick a golfer and a tier
            and their brand goes on that golfer's profile. No agents. No partnership deals with the platform. Just a
            direct connection between the person putting the money in and the person putting the work in.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 border-b border-border bg-muted">
        <div className="container-tight grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="overline">Our principles</div>
            <h2 className="font-display text-4xl md:text-5xl mt-3">Verified. Direct. Golfer-first.</h2>
          </div>
          <div className="md:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-10">
            {[
              ["Verified profiles", "Every golfer is reviewed before going public. Club, level, references, we check the story before you back it."],
              ["Direct funding", "Money you contribute goes to the golfer, not to the platform. We take a small transaction fee, no more."],
              ["Transparent goals", "Funding goals are itemised, tournament travel, coaching, entry fees, so you can see exactly what your contribution unlocks."],
              ["Golfer-owned", "Golfers own their profile, updates and story. We provide the tools, they do the talking."],
            ].map(([t, d]) => (
              <div key={t} className="border-t border-border pt-6">
                <div className="font-display text-2xl">{t}</div>
                <p className="mt-3 text-sm text-foreground/70 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="container-tight text-center">
          <div className="overline">Join us</div>
          <h2 className="font-display text-4xl md:text-6xl mt-3 max-w-3xl mx-auto leading-[1.05]">
            Whether you're a golfer raising funds, or someone who wants to back one, there's a place for you here.
          </h2>
          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            <Link to="/golfers" className="btn-primary uppercase tracking-[0.18em] text-[12px]" data-testid="about-cta-support">Back a golfer</Link>
            <Link to="/apply" className="btn-outline uppercase tracking-[0.18em] text-[12px]" data-testid="about-cta-apply">Apply for funding</Link>
            <Link to="/sponsors" className="btn-outline uppercase tracking-[0.18em] text-[12px]" data-testid="about-cta-sponsor">Sponsor a golfer</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
